module.exports = __webpack_public_path__ + "themes/mf/img/button.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/button.png
// module id = 69
// module chunks = 3